import * as type from "../types";

export const userSearchRequest = (value, organizationId) => ({
  type: type.USER_SEARCH_REQUESTED,
  payload: {
    value,
    organizationId,
  },
});

export const userSearchSucceeded = (data) => ({
  type: type.USER_SEARCH_SUCCEEDED,
  payload: data,
});

export const userSearchFailed = () => ({
  type: type.USER_SEARCH_FAILED,
});

export const userLookupRequest = (data) => ({
  type: type.USER_LOOKUP_REQUESTED,
  payload: data,
});

export const userLookupSucceeded = (data) => {
  data?.userLookupList?.unshift({
    value: "",
    name: "Tümü",
  });
  return { type: type.USER_LOOKUP_SUCCEEDED, payload: data };
};

export const userLookupFailed = (data) => ({
  type: type.USER_LOOKUP_FAILED,
  payload: data,
});
